import React, { useState } from 'react';
import { sendingDomainService } from '../services/sendingDomainService';

const EmailAddressDebugger: React.FC = () => {
  const [email, setEmail] = useState('charlieparra12345@gmail.com');
  const [userId, setUserId] = useState('test-user');
  const [result, setResult] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);

  const testEmailAddress = async () => {
    setIsLoading(true);
    try {
      console.log('Testing email address:', email);
      console.log('User ID:', userId);
      
      const sendingAddress = await sendingDomainService.getSendingAddressForEmail(userId, email);
      console.log('Generated sending address:', sendingAddress);
      
      const replyTo = await sendingDomainService.getReplyToEmail(sendingAddress);
      console.log('Reply-to email:', replyTo);
      
      setResult(`
Input: ${email}
User ID: ${userId}
Generated Sending Address: ${sendingAddress}
Reply-To Email: ${replyTo || 'None'}
      `);
    } catch (error) {
      console.error('Error testing email address:', error);
      setResult(`Error: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Email Address Debugger</h3>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email Address
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Enter email address"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            User ID
          </label>
          <input
            type="text"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Enter user ID"
          />
        </div>
        
        <button
          onClick={testEmailAddress}
          disabled={isLoading}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Testing...' : 'Test Email Address'}
        </button>
        
        {result && (
          <div className="mt-4 p-4 bg-gray-50 border rounded-md">
            <h4 className="font-medium text-gray-900 mb-2">Result:</h4>
            <pre className="text-sm text-gray-700 whitespace-pre-wrap">{result}</pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailAddressDebugger;
